import './CommentTab.style.less'
import { Skeleton } from 'antd'
import { useQuery } from 'react-query'
import HttpRequest from '@/config/axios.config'
import { ICommentDataField } from '@/screens/Order/Pages/OrderOverview/components/TimeAndAction/components/DetailSection/components/TaskTemplate/Fields/CommentField/components/CommentFieldDialog/CommentFieldDialog.interface'
import AddNewCommentSection from '@/screens/Order/Pages/OrderOverview/components/TimeAndAction/components/DetailSection/components/TaskTemplate/Fields/CommentField/components/CommentFieldDialog/components/AddNewCommentSection/AddNewCommentSection'
import CommentDisplaySection from '@/screens/Order/Pages/OrderOverview/components/TimeAndAction/components/DetailSection/components/TaskTemplate/Fields/CommentField/components/CommentFieldDialog/components/CommentDisplaySection/CommentDisplaySection'
import { useEffect } from 'react'
import socket from '@/utils/socket'

interface Props {
  task: any
  open: boolean
}

function CommentTab({ task, open }: Props) {
  ///Join room with tasks ID for socket comment to work///
  useEffect(() => {
    if (open) {
      socket.emit('join', `comment_${task?.id}`)
    } else {
      socket.emit('leave', `comment_${task?.id}`)
    }
  }, [open])

  ///For refetching comment using socket///
  useEffect(() => {
    setTimeout(() => {
      if (socket) {
        socket.on('comment', () => {
          refetch()
        })
      }
    }, 1000)
    return () => {
      socket.off('comment', () => {
        refetch()
      })
    }
  }, [socket.emit('join', `comment_${task?.id}`).connected])

  const { isLoading, data, refetch } = useQuery(
    ['commentQuery', task?.id, open],
    async () => {
      let response = null
      response = await HttpRequest.get(`comments/tasks/${task?.id}`)
      return response
    },
    {
      enabled: !!open,
    }
  )

  return (
    <div>
      <div className="wrap-comments">
        <div className="row">
          <div className="col-12">
            {isLoading ? (
              <Skeleton active />
            ) : (
              data?.data?.data?.map((comment: ICommentDataField, index) => {
                if (comment.type === 'reply') return <></>
                return (
                  <div key={`${index}-${comment?.id}`}>
                    <CommentDisplaySection
                      onReload={refetch}
                      section={'byOrderId'}
                      data={comment}
                      task={task}
                      taskId={task?.id}
                    />
                  </div>
                )
              })
            )}
            <AddNewCommentSection comment={data} data={task} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommentTab
